/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetLivestockKpiSummaryQueryResponse, GetLivestockKpiSummaryPathParams, GetLivestockKpiSummaryQueryParams, GetLivestockKpiSummary400, GetLivestockKpiSummary401, GetLivestockKpiSummary403, GetLivestockKpiSummary404, GetLivestockKpiSummary409, GetLivestockKpiSummary500 } from "../../types/analyticsController/GetLivestockKpiSummary.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetLivestockKpiSummaryUrl(organizationId: GetLivestockKpiSummaryPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/analytics/livestock-kpi-summary` as const }
  return res
}

/**
 * @summary Livestock KPI summary — growth, stocking, reproduction and mortality — for the organization (optionally one farm via ?establishmentId, optionally a subset via ?sections=)
 * {@link /api/organizations/:organizationId/analytics/livestock-kpi-summary}
 */
export async function getLivestockKpiSummary(organizationId: GetLivestockKpiSummaryPathParams["organizationId"], params?: GetLivestockKpiSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLivestockKpiSummaryQueryResponse, ResponseErrorConfig<GetLivestockKpiSummary400 | GetLivestockKpiSummary401 | GetLivestockKpiSummary403 | GetLivestockKpiSummary404 | GetLivestockKpiSummary409 | GetLivestockKpiSummary500>, unknown>({ method : "GET", url : getGetLivestockKpiSummaryUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}